import React, { useState } from 'react';
import { OB_STEPS, GREEN, BLACK, GREEN_LIGHT } from '../constants';
import { cardGreen, cardBlack, card, mono } from '../styles';
import { NavBar, Btn } from '../components/UI';
import Agreement    from './Agreement';
import Questionnaire from './Questionnaire';
import Logins       from './Logins';
import FileUpload   from './FileUpload';

export default function OnboardingHub({ client, onUpdate, onHandover }) {
  const [activeStep, setActiveStep] = useState(null);
  const ob       = client.onboarding;
  const done     = ob.completedSteps || [];
  const pct      = Math.round((done.length / OB_STEPS.length) * 100);
  const allDone  = done.length === OB_STEPS.length;
  const nextStep = OB_STEPS.find(s => !done.includes(s.id));

  function updateOB(updated) {
    onUpdate({ ...client, onboarding: updated });
  }

  if (activeStep) {
    const S = OB_STEPS.find(x => x.id === activeStep);
    return (
      <div style={{ minHeight: '100vh', background: '#f5f5f2' }}>
        <NavBar
          title={client.name}
          sub={`Onboarding — ${S.label}`}
          onBack={() => setActiveStep(null)}
          right={<Btn v="outline" sm onClick={() => setActiveStep(null)}>Back to checklist</Btn>}
        />
        <div style={{ maxWidth: 700, margin: '0 auto', padding: '24px 16px' }}>
          <div style={card()}>
            {activeStep === 'agreement'     && <Agreement ob={ob} onUpdate={u => { updateOB(u); if (u.signed) setActiveStep(null); }} />}
            {activeStep === 'questionnaire' && <Questionnaire ob={ob} onUpdate={u => { updateOB(u); setActiveStep(null); }} />}
            {activeStep === 'logins'        && <Logins ob={ob} onUpdate={u => { updateOB(u); setActiveStep(null); }} />}
            {activeStep === 'files'         && <FileUpload ob={ob} onUpdate={updateOB} clientName={client.name} />}
            {activeStep === 'files' && done.includes('files') && (
              <div style={{ marginTop: 12 }}>
                <Btn v="outline" onClick={() => setActiveStep(null)}>Back to checklist</Btn>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', background: '#f5f5f2' }}>
      <NavBar
        title={client.name}
        sub="Onboarding"
        right={allDone && <Btn v="black" sm onClick={onHandover}>View Handover Guide</Btn>}
      />
      <div style={{ maxWidth: 640, margin: '0 auto', padding: '24px 16px' }}>

        {/* Hero card */}
        <div style={cardGreen({ marginBottom: 12, display: 'flex', justifyContent: 'space-between', alignItems: 'center' })}>
          <div>
            <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: 1, textTransform: 'uppercase', color: 'rgba(0,0,0,.4)', marginBottom: 6, fontFamily: 'monospace' }}>
              Onboarding
            </div>
            <div style={{ fontSize: 20, fontWeight: 800, marginBottom: 6 }}>Let's get you set up</div>
            <div style={{ fontSize: 13, opacity: 0.7 }}>4 steps — about 10 minutes</div>
          </div>
          <div style={{ position: 'relative', flexShrink: 0, marginLeft: 16 }}>
            <svg width={60} height={60} style={{ transform: 'rotate(-90deg)' }}>
              <circle cx={30} cy={30} r={24} fill="none" stroke="rgba(0,0,0,.15)" strokeWidth={4} />
              <circle cx={30} cy={30} r={24} fill="none" stroke={BLACK} strokeWidth={4}
                strokeDasharray={150.8} strokeDashoffset={150.8 * (1 - pct / 100)} strokeLinecap="round" />
            </svg>
            <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 13, fontWeight: 800 }}>
              {pct}%
            </div>
          </div>
        </div>

        {/* Step list */}
        {OB_STEPS.map((s, i) => {
          const isDone = done.includes(s.id);
          const isNext = !isDone && nextStep && nextStep.id === s.id;
          return (
            <div
              key={s.id}
              onClick={() => setActiveStep(s.id)}
              style={card({
                marginBottom: 8, cursor: 'pointer',
                display: 'flex', alignItems: 'center', gap: 14,
                borderColor: isNext ? GREEN : isDone ? '#c5f0a0' : '#e0e0d8',
                background: isDone ? '#f8fff0' : '#fff',
              })}
            >
              <div style={{
                width: 42, height: 42, borderRadius: 11, flexShrink: 0,
                background: isDone ? GREEN : isNext ? BLACK : '#f5f5f2',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: 14, fontWeight: 800,
                color: isDone ? BLACK : isNext ? '#fff' : '#999',
              }}>
                {isDone ? 'OK' : String(i + 1)}
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: 700, fontSize: 14 }}>{s.label}</div>
                <div style={mono}>
                  {isDone ? 'Complete' : isNext ? 'Tap to start' : `Step ${i + 1} of 4`}
                </div>
              </div>
              {isNext && (
                <span style={{ background: GREEN, color: BLACK, padding: '4px 12px', borderRadius: 20, fontSize: 12, fontWeight: 700 }}>
                  Start
                </span>
              )}
              {isDone && <span style={{ color: '#16a34a', fontSize: 13, fontWeight: 700 }}>Done</span>}
            </div>
          );
        })}

        {allDone && (
          <div style={cardBlack({ textAlign: 'center', marginTop: 10 })}>
            <div style={{ fontWeight: 800, fontSize: 18, marginBottom: 6 }}>All done!</div>
            <div style={{ fontSize: 13, opacity: 0.6, marginBottom: 16 }}>
              Your account manager will be in touch within 24 hours.
            </div>
            <Btn onClick={onHandover}>View Handover Guide</Btn>
          </div>
        )}
      </div>
    </div>
  );
}
